import { useEffect, useState } from "react";
import { api, GALLERY_CATEGORIES } from "@/lib/api";
import { useContent } from "@/context/ContentContext";

export default function Gallery() {
  const c = useContent().pages.gallery;
  const [cat, setCat] = useState("all");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery", { params: cat !== "all" ? { category: cat } : {} }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
      <div className="max-w-3xl">
        <div className="text-terracotta text-sm tracking-widest uppercase font-medium">{c.eyebrow}</div>
        <h1 className="mt-2 font-serif font-bold text-5xl md:text-6xl leading-tight">{c.heading}</h1>
      </div>
      <div className="mt-10 flex flex-wrap gap-2" data-testid="gallery-filter-chips">
        {GALLERY_CATEGORIES.map((c) => (
          <button key={c.id} onClick={() => setCat(c.id)} data-testid={`gallery-filter-${c.id}`}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${cat === c.id ? "bg-terracotta text-white" : "bg-white text-charcoal hover:bg-cream-alt"}`}>
            {c.label}
          </button>
        ))}
      </div>
      <div className="mt-10 columns-2 md:columns-3 gap-6 space-y-6">
        {items.map((g) => (
          <div key={g.id} className="break-inside-avoid" data-testid={`gallery-item-${g.id}`}>
            <img src={g.url} alt={g.caption} className="w-full rounded-3xl shadow-card"/>
            {g.caption && <div className="mt-2 text-sm text-charcoal-muted">{g.caption}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
